import { SITE } from '../data/site';
import { Icon, IconId } from './icons';

export interface ProofItem {
  icon: IconId;
  label: string;
  value: string;
}

interface ProofStripProps {
  items?: ProofItem[];
}

const CERT_CODES = SITE.certifications.map(c => c.code).join(', ');

/** Default items for the Home hero. Other pages pass their own. */
export const DEFAULT_PROOF_ITEMS: ProofItem[] = [
  { icon: 'award', label: 'Microsoft Certified', value: CERT_CODES },
  {
    icon: 'location',
    label: `Founded ${SITE.founded}`,
    value: `${SITE.location.city}, ${SITE.location.region} · ${SITE.location.serving}`,
  },
  { icon: 'speed', label: '2 – 6 weeks', value: 'To your first working automation' },
  {
    icon: 'check',
    label: 'Free 15-min consultation',
    value: 'No sales pitch, just a conversation',
  },
];

/** Trust-signal band under a hero: certifications, founding, speed, free consult. */
function ProofStrip({ items = DEFAULT_PROOF_ITEMS }: ProofStripProps) {
  return (
    <div className="proof-strip">
      <div className="container proof-strip-inner">
        {items.map(item => (
          <div className="proof-item" key={item.label}>
            <span className="proof-icon">
              <Icon id={item.icon} size={20} />
            </span>
            <div>
              <span className="proof-label">{item.label}</span>
              <span className="proof-value">{item.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProofStrip;
